import { render } from "./UserMessageItem.vue?vue&type=template&id=e7df0e40&scoped=true"
import script from "./UserMessageItem.vue?vue&type=script&lang=ts"
export * from "./UserMessageItem.vue?vue&type=script&lang=ts"

import "./UserMessageItem.vue?vue&type=style&index=0&id=e7df0e40&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e7df0e40"

export default script